import {ApolloError} from 'apollo-client';
import {LocCoords} from '../interfaces';

interface AircraftMapData {
    status: 'BASE' | 'AIR' | 'CHECK';
    departure?: string;
    departureID?: string;
    departureCoordinates?: LocCoords;
    destination?: string;
    destinationID?: string;
    destinationCoordinates?: LocCoords;
}

export function hasCoordinates(coordinates?: LocCoords): boolean {
    return Number.isFinite(coordinates?.latitude) && Number.isFinite(coordinates?.longitude);
}

export function getMissingMapLocations(data: AircraftMapData) {
    const locations = [{
        id: data.departureID,
        name: data.departure || 'the departure location',
        coordinates: data.departureCoordinates
    }];
    if (data.status === 'AIR') {
        locations.push({
            id: data.destinationID,
            name: data.destination || 'the destination location',
            coordinates: data.destinationCoordinates
        });
    }
    return locations.filter(location => !hasCoordinates(location.coordinates));
}

export function isCoordinateQueryError(error?: ApolloError): boolean {
    return !error?.networkError && error?.graphQLErrors?.length > 0
        && error.graphQLErrors.every(({path}) =>
            path?.[0] === 'GetDispatchByID'
            && (path[1] === 'departingDoc' || path[1] === 'destinationDoc')
            && path[2] === 'resolvedCoordinates'
        );
}
